import Image1 from "../../images/about-us/image1.png";
import Image2 from "../../images/about-us/image2.png";
import Image3 from "../../images/about-us/image3.png";
import Image4 from "../../images/about-us/image4.png";
import BG from "../../images/about-us/bg-image.png";

function AboutHero({scroll}) {
  return (
    <div className="about-us-hero">
      <div className="heading">
        <h1>Smart Minds, Real Impact, One Team</h1>
        <p>
          At Brandonetech, we're a happy team that loves what we do. We build
          smart solutions, but we also thrive on collaboration, laughter, and
          shared wins — because great work starts with great people.
        </p>
        <button onClick={scroll}>
          <p>Learn more</p>
          <div />
        </button>
      </div>
      <div className="image1">
        <img src={Image1} alt="default" />
      </div>
      <div className="image2">
        <img src={Image2} alt="default" />
      </div>
      <div className="image3">
        <img src={Image3} alt="default" />
      </div>
      <div className="image4">
        <img src={Image4} alt="default" />
      </div>
      <img src={BG} alt="bg" className="bg-image" />
    </div>
  );
}

export default AboutHero;
